import { useEffect, useState } from 'react'

export const useDelayedLoading = (loading: boolean, delay = 1000): boolean => {
  const [show, setShow] = useState(false)

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>

    if (loading) {
      timer = setTimeout(() => {
        setShow(true)
      }, delay)
    } else {
      setShow(false)
    }

    return () => {
      if (timer) clearTimeout(timer)
    }
  }, [loading, delay])

  return show
}
